import { tns } from 'tiny-slider/src/tiny-slider';
import BaseComponent from 'foundation/base-component';

class BroadcastersComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.carousel = null;
        this.slideCount = this.getSlideCount();
        this.handleResize = this.handleResize.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['slides'];
    }

    init() {
        this.toggleCarousel();
        window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
        this.toggleCarousel();
    }

    toggleCarousel() {
        const shouldEnable = this.shouldEnableCarousel();

        if (shouldEnable && !this.carousel) {
            this.carousel = tns({
                container: this.refs.slides,
                items: 1,
                slideBy: 1,
                gutter: 0,
                loop: true,
                rewind: true,
                nav: true,
                navPosition: 'bottom',
                controls: false,
                autoplay: true,
                autoplayButtonOutput: false,
                interval: 3000,
                mouseDrag: true,
                swipeAngle: false
            });
        }

        if (!shouldEnable && this.carousel) {
            this.carousel.destroy();
            this.carousel = null;
        }
    }

    shouldEnableCarousel() {
        return this.slideCount > 1;
    }

    getSlideCount() {
        return this.refs.slides ? this.refs.slides.children.length : 0;
    }

    onDestroy() {
        window.removeEventListener('resize', this.handleResize);

        if (this.carousel) {
            this.carousel.destroy();
            this.carousel = null;
        }
    }
}

export default BroadcastersComponent;
